/* eslint-disable camelcase */
/* eslint-disable react/require-default-props */
import { createContext, ReactElement, ReactNode, useState } from 'react';
import type {
  clientDataType,
  getGuarantorsType,
} from '@/services/pre-enrollment/types';
import type { processDateType } from '@/hooks/authorization/useClient/useClient';

type StudentProps = {
  hasFifteenDelayApproval: boolean;
  clientId: string;
  step: string;
  guarantorsPerson: getGuarantorsType[];
  mscPipelineId: string;
  selectionProcessId: string;
  processNameAbbreviation: string;
  candidateApplicationId: string;
  userId: string;
  processDateInfo: processDateType;
  clientData: clientDataType;
  paymentMethod: string;
  isMsc: string;
};

export type StudentContextProps = {
  state: StudentProps;
  setState: React.Dispatch<React.SetStateAction<StudentProps>>;
};

type StudentProviderProps = {
  children: ReactNode;
  paymentMethod?: string;
};

const DEFAULT_VALUE: StudentContextProps = {
  state: {
    hasFifteenDelayApproval: false,
    clientId: '',
    step: '',
    guarantorsPerson: [],
    mscPipelineId: '',
    selectionProcessId: '',
    processNameAbbreviation: '',
    candidateApplicationId: '',
    paymentMethod: '',
    isMsc: '',
    userId: '',
    processDateInfo: {
      limitDateAssignatureContract: '',
      limitDateFinancingRequest: '',
      processDueDate: '',
    },
    clientData: {
      address: '',
      address_complement: '',
      birthdate: '',
      birthplace: '',
      city: '',
      cpf: '',
      cpf_document_url: '',
      document_selfie_url: '',
      marital_status: '',
      monthly_income: '',
      name: '',
      nationality: '',
      neighborhood: '',
      politically_exposed_person: false,
      proof_of_residency_document_url: '',
      residence_number: '',
      residence_type: '',
      rg: '',
      rg_document_url: '',
      rg_issuing_body: '',
      rg_issuing_state: '',
      state: '',
      student_financing_check: '',
      zipcode: '',
    },
  },
  setState: () => {
    // default function
  },
};

const StudentContext = createContext<StudentContextProps>(DEFAULT_VALUE);

const StudentContextProvider = ({
  children,
  paymentMethod = '',
}: StudentProviderProps): ReactElement => {
  const [state, setState] = useState({ ...DEFAULT_VALUE.state, paymentMethod });

  return (
    <StudentContext.Provider value={{ state, setState }}>
      {children}
    </StudentContext.Provider>
  );
};

export { StudentContextProvider };
export default StudentContext;
